;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import Image from "next/image"

function ProviderSection({
  providerDisplayName,
  primaryCredentialAndRole,
  providerPicture,
}) {
  const getInitials = () => {
    const parts = String(providerDisplayName || "")
      .trim()
      .split(/\s+/)
      .filter(Boolean)
    return `${parts[0]?.[0] ?? ""}${parts[1]?.[0] ?? ""}`.toUpperCase()
  }

  const renderPicture = () => {
    return (
      <div className={"mr-[8px] flex-shrink-0"}>
        {providerPicture ? (
          <Image
            src={providerPicture}
            height={74}
            width={74}
            alt={"provider picture"}
            className={"rounded-full border-solid border-black border-[3px]"}
          />
        ) : (
          // No photo: show initials (matches PersonalAvatar) and avoid passing an
          // empty/undefined src to next/image.
          <div
            className={
              "flex h-[74px] w-[74px] items-center justify-center rounded-full border-[3px] border-solid border-black bg-[#092C3C] font-bebas text-[26px] text-[#00B2FF] select-none"
            }
            aria-label={"provider picture"}
          >
            {getInitials()}
          </div>
        )}
      </div>
    )
  }

  const renderName = () => {
    return (
      <div className="font-semibold text-[18px]	text-black tracking-[0.54px]">
        {providerDisplayName}
      </div>
    )
  }

  const renderTitle = () => {
    return (
      <div className="text-[#AAAAAA] text-[18px]">{primaryCredentialAndRole}</div>
    )
  }
  return (
    <div className="pt-[20px] flex flex-row">
      {renderPicture()}
      <div className="flex flex-col">
        {renderName()}
        {renderTitle()}
      </div>
    </div>
  )
}

export default ProviderSection
